import { Component } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';

import { ChrComponentsModule } from '@ciphr-design-system/angular';

@Component({
  selector: 'ciphr-page-not-found',
  imports: [ChrComponentsModule, TranslocoDirective],
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent {}
